import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from './plugin'
import type { State } from './state'

/**
 * Core actions for this {@link Plugin}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /**
     * TODO:
     */
    display: store.actions.request({
      input: store.actions.Data.asIs<
        | {
            readonly id: ec.models.EntityId
          }
        | 'next'
        | 'previous'
        | 'first'
        | 'last'
      >(),
      // output: store.actions.Data.asIs<{
      //   readonly id: ec.models.EntityId
      // }>(),
      //  TODO: do we really need this?
      output: store.actions.Data.NONE,
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
